import { FullNRITable } from 'components/nri-table/nri-table';
import { TractNRI, TractNRIColumns } from 'components/nri-table/types';

interface SlotRollupNRITableProps {
  slotNRIRows: TractNRI[];
  isLoading: boolean;
  tableId?: string;
}

const SLOT_ROLLUP_NRI_COLUMNS: Array<TractNRIColumns> = [
  'slotId',
  'unit',
  'totalSlotNri',
  'totalSlotWi',
  'interestType',
  'unitSource',
  'unitDevelopmentType',
  'wellName',
  'wellStatus',
  'typeCurveStatus',
  'operator',
  'holeDirection',
  'formation',
  'basin',
  'tier',
  'slotNumber',
  'permitDate',
  'spudDate',
  'rigReleaseDate',
  'completionDate',
  'firstProductionDate',
];

export const SlotRollupNRITable = ({
  slotNRIRows,
  isLoading,
  tableId = 'slot-rollup-table',
}: SlotRollupNRITableProps) => {
  return (
    <FullNRITable
      tractNRIRows={slotNRIRows}
      isLoading={isLoading}
      tableId={tableId}
      tractNRIColumns={SLOT_ROLLUP_NRI_COLUMNS}
      subtractNRIColumns={[]}
    />
  );
};
